import { SitePageContext } from '../../types/generated/graphql-types'
import { notEmpty } from '../utilities/filters'

export const mapLanguageVersions = ({ languageVersions }: SitePageContext) =>
  languageVersions?.filter(notEmpty).map(languageVersion => ({
    language: languageVersion.language ?? undefined,
    path: languageVersion.path ?? undefined,
    urlFragments: languageVersion.urlFragments?.filter(notEmpty) ?? undefined,
  })) ?? undefined
